module.exports = __webpack_public_path__ + "img/3.93585be3.jpg";